import CountrySelector from '@/components/common/CountrySelector';
import { env, getSpacehomeUrl, getFlowingMallUrl } from '@/constant/configure';
import sodomallLogo from '@/assets/images/logo/sodomall_logo.png';
import soduBrandMark from '@/assets/sodu/brand-mark.svg';
import { dialogOpen } from '@/modules/MuiDialog';
import LoginDialog from '@/pages/dialogs/LoginDialog';
import { checkMallSession, signOutSession } from '@/services/auth.service';
import { useCurrentMallStore, useSessionStore, useSpaceUserV2Store, useUserStore } from '@/store';
import { useLanguage } from '@/store/modules/languageStore';
import sessionStore from '@/store/modules/sessionStore';
import { broadcastLogout } from '@/utils/authBroadcast';
import { notifyGloreelsLogout } from '@/services/sso.service';
// GloreelsLinkButton 제거 — 네비바 연동 버튼 폐지, 편집기 고정 블록 "글로릴스에서 가져오기"로 이동
// import GloreelsLinkButton from '@/externals/ddm/components/GloreelsLinkButton';
// GloreelsLinkNotice 제거 — 자동 연동 안내 팝업 폐지(수동 가져오기 모델로 전환)
// import GloreelsLinkNotice from '@/externals/ddm/components/GloreelsLinkNotice';
import { isSodomallPartnerDomain } from '@/utils/checkDomain';
import LanguageIcon from '@mui/icons-material/Language';
import LinkIcon from '@mui/icons-material/Link';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ViewCarouselRoundedIcon from '@mui/icons-material/ViewCarouselRounded';
import BrushRoundedIcon from '@mui/icons-material/BrushRounded';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import InventoryIcon from '@mui/icons-material/Inventory';
import {
    AppBar,
    Avatar,
    Badge,
    Box,
    Button,
    Divider,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface DDMNavBarProps {
    setAppBarHeight?: (height: number) => void;
}

// Flowing Space (non-Sodomall) 디자인 토큰
const FLOWING_INK = '#0A1628';
const FLOWING_SKY = '#09A8FA';

// 소셜듀오 핑크 브랜드 토큰 (non-Sodomall 화면용)
const SODU_BRAND = '#ff6b9d';
const SODU_BRAND_HOVER = '#e85690';
const SODU_BRAND_SOFT = '#ffe8f0';
const SODU_APPBAR_BG = '#fff5f8';
const SODU_APPBAR_BORDER = 'rgba(255, 107, 157, 0.18)';

// 소셜듀오 데스크탑 nav 버튼(contained) 스타일 — 그라데이션 액티브 + 정돈된 인액티브
const soduActionSx = (isActive: boolean) => ({
    minHeight: 38,
    px: 2.5,
    py: 0.85,
    borderRadius: '999px',
    background: isActive ? 'linear-gradient(135deg, #ff8bb7 0%, #ff6b9d 100%)' : '#FFFFFF',
    color: isActive ? '#FFFFFF' : SODU_BRAND_HOVER,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: '-0.01em',
    textTransform: 'none' as const,
    cursor: 'pointer',
    border: isActive ? '1px solid transparent' : `1px solid ${SODU_APPBAR_BORDER}`,
    boxShadow: isActive ? '0 6px 18px rgba(255, 107, 157, 0.38)' : '0 1px 2px rgba(255, 107, 157, 0.08)',
    willChange: 'transform, box-shadow',
    transition: 'background 0.2s ease, color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease',
    '&:hover': {
        background: isActive ? 'linear-gradient(135deg, #ff6b9d 0%, #e85690 100%)' : SODU_BRAND_SOFT,
        borderColor: isActive ? 'transparent' : SODU_BRAND,
        transform: 'translateY(-1px)',
        boxShadow: isActive ? '0 8px 22px rgba(255, 107, 157, 0.46)' : '0 3px 10px rgba(255, 107, 157, 0.18)',
    },
});

// Flowing Space 데스크탑 nav 링크 스타일
const FLOWING_NAV_MUTED = '#5A6478';
const flowingActionSx = (isActive: boolean) => ({
    position: 'relative' as const,
    minWidth: 'auto',
    minHeight: 36,
    px: 1.25,
    py: 0.75,
    borderRadius: 0,
    backgroundColor: 'transparent',
    fontSize: 14,
    fontWeight: isActive ? 600 : 500,
    letterSpacing: '-0.01em',
    textTransform: 'none' as const,
    cursor: 'pointer',
    color: isActive ? FLOWING_INK : FLOWING_NAV_MUTED,
    willChange: 'color',
    transition: 'color 0.2s ease',
    '&::after': {
        content: '""',
        position: 'absolute',
        left: 10,
        right: 10,
        bottom: 4,
        height: '2px',
        backgroundColor: FLOWING_SKY,
        transform: isActive ? 'scaleX(1)' : 'scaleX(0)',
        transformOrigin: 'center',
        transition: 'transform 0.25s ease',
        willChange: 'transform',
    },
    '&:hover': {
        backgroundColor: 'transparent',
        color: FLOWING_INK,
        '&::after': { transform: 'scaleX(1)' },
    },
});

// Flowing Space 모바일 메뉴 항목 스타일
const flowingMobileItemSx = {
    justifyContent: 'flex-start',
    color: FLOWING_INK,
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: '-0.01em',
    py: 2,
    px: 1.5,
    borderBottom: '1px solid rgba(10, 22, 40, 0.08)',
    textTransform: 'none' as const,
    cursor: 'pointer',
    willChange: 'background-color',
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: 'rgba(9, 168, 250, 0.06)',
    },
};

// 사용자 드롭다운 메뉴 스타일
const userDropdownMenuSx = {
    '& .MuiPaper-root': {
        mt: 1.5,
        minWidth: 272,
        borderRadius: '14px',
        boxShadow: '0 16px 40px rgba(10, 22, 40, 0.12), 0 2px 8px rgba(10, 22, 40, 0.06)',
        border: '1px solid rgba(10, 22, 40, 0.08)',
        overflow: 'hidden',
        backgroundColor: '#FFFFFF',
    },
    '& .MuiList-root': {
        py: 1.25,
    },
    '& .MuiMenuItem-root': {
        px: 2.25,
        py: 1.5,
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        willChange: 'background-color',
        transition: 'background-color 0.2s ease',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 10,
            bottom: 10,
            width: '3px',
            borderRadius: '0 2px 2px 0',
            backgroundColor: FLOWING_SKY,
            opacity: 0,
            transition: 'opacity 0.2s ease',
        },
        '&:hover': {
            backgroundColor: 'rgba(9, 168, 250, 0.06)',
            '&::before': { opacity: 1 },
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(9, 168, 250, 0.08)',
            '&:hover': {
                backgroundColor: 'rgba(9, 168, 250, 0.12)',
            },
        },
    },
};

const userDropdownIconWrapperSx = {
    minWidth: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    mr: 1.25,
};

const userDropdownIconSx = { fontSize: 20, color: FLOWING_INK };

const userDropdownTextSx = {
    '& .MuiTypography-root': {
        color: FLOWING_INK,
        fontWeight: 500,
        fontSize: '15px',
        letterSpacing: '-0.2px',
    },
};

const userDropdownDividerSx = {
    my: 1,
    mx: 2,
    background: 'linear-gradient(90deg, transparent 0%, rgba(10, 22, 40, 0.14) 50%, transparent 100%)',
    height: '1px',
    border: 'none',
};

// 사용자 프로필 박스 스타일 (Workspace + User 2단 카드)
const FLOWING_NAV_MUTED_2 = '#6B7689';
const userProfileBoxSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    cursor: 'pointer',
    pl: 1,
    pr: 1.25,
    py: 0.375,
    minWidth: { xs: 'auto', md: 188 },
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    border: '1.5px solid rgba(10, 22, 40, 0.12)',
    willChange: 'background-color, border-color',
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    '&:hover': {
        backgroundColor: 'rgba(9, 168, 250, 0.06)',
        borderColor: FLOWING_SKY,
        '& .profile-caret': {
            transform: 'translateY(1px)',
            color: FLOWING_SKY,
        },
    },
};

const userProfileAvatarSx = {
    width: 32,
    height: 32,
    bgcolor: FLOWING_INK,
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: 600,
    flexShrink: 0,
};

const userProfileTextWrapperSx = {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
    minWidth: 0,
    flex: 1,
    lineHeight: 1.15,
};

const userProfileMallSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 0.375,
    fontSize: 10.5,
    fontWeight: 500,
    letterSpacing: '-0.01em',
    color: FLOWING_NAV_MUTED_2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
    lineHeight: 1.1,
    '& svg': { fontSize: 11, color: FLOWING_NAV_MUTED_2 },
};

const userProfileNameSx = {
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '-0.01em',
    color: FLOWING_INK,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
    lineHeight: 1.2,
};

const userProfileCaretSx = {
    fontSize: 16,
    color: 'rgba(10, 22, 40, 0.4)',
    flexShrink: 0,
    willChange: 'transform, color',
    transition: 'transform 0.2s ease, color 0.2s ease',
};

// 로그인 버튼 스타일
const loginButtonSx = {
    color: FLOWING_INK,
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '-0.01em',
    px: 2.25,
    py: 0.625,
    minHeight: 36,
    textTransform: 'none' as const,
    border: '1.5px solid rgba(10, 22, 40, 0.12)',
    borderRadius: '999px',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    willChange: 'background-color, border-color',
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    '&:hover': {
        backgroundColor: 'rgba(9, 168, 250, 0.06)',
        borderColor: FLOWING_SKY,
    },
};

const DDMNavBar = ({ setAppBarHeight }: DDMNavBarProps) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { nickname, image_url } = useUserStore();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('KR');
    const [userMenuAnchor, setUserMenuAnchor] = useState<null | HTMLElement>(null);
    const [aiMenuAnchor, setAiMenuAnchor] = useState<null | HTMLElement>(null);
    const appBarRef = useRef<HTMLDivElement>(null);

    const { t } = useTranslation();
    const { userId, mallId, accessToken } = useSessionStore();
    const { mallPath, name: currentMallName } = useCurrentMallStore();
    const { path: spacePath, grade_name } = useSpaceUserV2Store();
    const { getCurrentCountryCode } = useLanguage();
    const isUserLoggedIn = !!(accessToken && userId);

    // 소도몰 역할인지 확인
    const isSodomall = grade_name === '소도몰';

    // mallPath가 없으면 spacePath를 사용
    const effectiveMallPath = mallPath || spacePath;

    // 프로필링크 메뉴(/studio)와 쇼핑몰 관리 메뉴(/mall)에서는 좌우 여백 제거
    const isFullWidthLayout =
        location.pathname.startsWith('/studio') ||
        location.pathname.startsWith('/mall') ||
        location.pathname.startsWith('/auto-dm') ||
        location.pathname.startsWith('/carousel') ||
        location.pathname.startsWith('/caricature');

    // 프로필링크 활성화 여부 (live 페이지 제외)
    const isProfileLinkActive =
        location.pathname === `/studio/${userId}` ||
        (location.pathname.startsWith(`/studio/${userId}/`) && !location.pathname.includes('/live/'));
    const isMallManageActive = location.pathname.startsWith('/mall/');
    const isAutoDmActive = location.pathname.startsWith('/auto-dm');
    const isCarouselActive = location.pathname.startsWith('/carousel');
    const isCaricatureActive = location.pathname.startsWith('/caricature');

    // 세션 검증 후 이동, 실패 시 로그인 팝업 (캐러셀 등 최상위 진입 공통)
    const navigateWithSessionGuard = async (to: string) => {
        const session = sessionStore.getState();
        if (session.accessToken && session.userId) {
            try {
                const isValidSession = await checkMallSession();
                if (isValidSession) {
                    navigate(to);
                    return;
                }
            } catch (error) {
                console.error('세션 검증 실패:', error);
            }
        }
        dialogOpen({
            innerElement: <LoginDialog onLoginSuccess={() => navigate(to)} />,
            maxWidth: false,
            sx: { '& .MuiDialog-paper': { maxWidth: '420px', width: '100%' } },
        });
    };

    // AppBar 높이 설정
    useEffect(() => {
        if (appBarRef.current && setAppBarHeight) {
            setAppBarHeight(appBarRef.current.clientHeight);
        }
    }, [setAppBarHeight]);

    // 언어 스토어에서 현재 국가 코드 가져오기
    useEffect(() => {
        const currentCountryCode = getCurrentCountryCode();
        setSelectedCountry(currentCountryCode);
    }, [getCurrentCountryCode]);

    // 국가 변경 핸들러
    const handleCountryChange = (countryCode: string) => {
        setSelectedCountry(countryCode);
        // CountrySelector에서 이미 언어 스토어를 업데이트하므로 여기서는 상태만 동기화
    };

    // 사용자 메뉴 핸들러
    const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setUserMenuAnchor(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setUserMenuAnchor(null);
    };

    // 로그아웃 핸들러
    const handleLogout = async () => {
        // 메뉴를 먼저 닫아서 anchorEl이 유효한 상태에서 처리
        handleUserMenuClose();

        // 메뉴가 완전히 닫힐 때까지 충분한 시간 대기 (트랜지션 포함)
        await new Promise((resolve) => setTimeout(resolve, 150));

        // 글로릴스에 백채널 전파 — ★ signOutSession() 이전, 토큰이 아직 살아있을 때.
        // 명시적 로그아웃에만 건다 — signOutSession 자체는 만료 경로에서도 불리므로
        // 거기 넣으면 소듀 쿠키가 새는 순간 글로릴스 사용자가 무작위로 튕긴다.
        notifyGloreelsLogout(sessionStore.getState().accessToken);

        // 다른 탭들에게 로그아웃 메시지 브로드캐스트
        broadcastLogout();

        await signOutSession();
        toast.success(t('auth.logoutSuccess'));

        // 토스트 메시지가 표시된 후 리다이렉트
        setTimeout(() => {
            // 소도몰 파트너 도메인인 경우 로그인 페이지로 이동
            if (isSodomallPartnerDomain()) {
                window.location.href = '/login';
            } else {
                window.location.reload();
            }
        }, 100);
    };

    return (
        <>
            <Box sx={{ position: 'relative' }}>
                <AppBar
                    ref={appBarRef}
                    position="sticky"
                    elevation={0}
                    sx={{
                        backgroundColor: isSodomall ? '#fff' : SODU_APPBAR_BG,
                        zIndex: 'calc( var(--v-zIndex-drawer) + 1)',
                        boxShadow: isSodomall
                            ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                            : '0 2px 12px rgba(255, 107, 157, 0.12)',
                        borderBottom: isSodomall ? '1px solid #e0e0e0' : `1px solid ${SODU_APPBAR_BORDER}`,
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: isFullWidthLayout ? 'none' : 2000,
                            margin: isFullWidthLayout ? 0 : '0 auto',
                            width: '100%',
                            px: { xs: 0, sm: 2, md: '40px', lg: '40px' },
                            py: { xs: 0.5, md: 0.75 },
                        }}
                    >
                        <Toolbar
                            disableGutters
                            sx={{
                                minHeight: { xs: 48, md: 56 },
                                justifyContent: 'space-between',
                                px: { xs: 2, sm: 0 },
                            }}
                        >
                            {/* 좌측 영역: 로고 */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {/* 모바일 메뉴 버튼 */}
                                {isMobile && (
                                    <IconButton
                                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                                        sx={{ color: '#222' }}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                )}

                                {/* 로고 */}
                                <Box
                                    component={Link}
                                    to={isSodomall ? `/mall/${mallId}` : `/studio/${userId}`}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: 'none',
                                        cursor: 'pointer',
                                        opacity: 1,
                                        transition: 'opacity 0.2s ease',
                                        '&:hover': { opacity: 0.75 },
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={isSodomall ? sodomallLogo : soduBrandMark}
                                        alt={isSodomall ? 'Sodomall' : '소셜듀오'}
                                        sx={{
                                            height: isSodomall ? { xs: 32, md: 52 } : { xs: 32, md: 40 },
                                            width: 'auto',
                                            mb: isSodomall ? 1 : 0,
                                        }}
                                    />
                                </Box>
                            </Box>

                            {/* 프로필링크 + 몰 관리 버튼 (왼쪽) */}
                            {!isMobile && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 3 }}>
                                    {/* 프로필링크 */}
                                    <Button
                                        onClick={async () => {
                                            // 실제 세션 검증 후 처리 (오래된 세션 방지)
                                            const session = sessionStore.getState();

                                            // localStorage에 세션이 있어도 실제 유효성 검증
                                            if (session.accessToken && session.userId) {
                                                try {
                                                    // 실제 세션 검증
                                                    const isValidSession = await checkMallSession();
                                                    if (isValidSession) {
                                                        // 검증 성공 시 최신 세션 정보로 이동
                                                        const currentSession = sessionStore.getState();
                                                        navigate(`/studio/${currentSession.userId}`);
                                                        return;
                                                    }
                                                } catch (error) {
                                                    console.error('세션 검증 실패:', error);
                                                }
                                            }

                                            // 세션이 없거나 검증 실패 시 로그인 팝업 표시
                                            dialogOpen({
                                                innerElement: (
                                                    <LoginDialog
                                                        onLoginSuccess={() => {
                                                            const currentSession = sessionStore.getState();
                                                            navigate(`/studio/${currentSession.userId}`);
                                                        }}
                                                    />
                                                ),
                                                maxWidth: false,
                                                sx: {
                                                    '& .MuiDialog-paper': {
                                                        maxWidth: '420px',
                                                        width: '100%',
                                                    },
                                                },
                                            });
                                        }}
                                        color={isSodomall ? 'info' : undefined}
                                        variant={
                                            isSodomall ? (isProfileLinkActive ? 'contained' : 'outlined') : 'contained'
                                        }
                                        disableElevation
                                        sx={isSodomall ? { borderRadius: '20px' } : soduActionSx(isProfileLinkActive)}
                                    >
                                        {t('studio.profileLinkManagement')}
                                    </Button>
                                    {/* 몰 관리 */}
                                    <Button
                                        variant={
                                            isSodomall ? (isMallManageActive ? 'contained' : 'outlined') : 'contained'
                                        }
                                        disableElevation
                                        color={isSodomall ? 'info' : undefined}
                                        onClick={async () => {
                                            // 실제 세션 검증 후 처리 (오래된 세션 방지)
                                            const session = sessionStore.getState();

                                            // localStorage에 세션이 있어도 실제 유효성 검증
                                            if (session.accessToken && session.userId) {
                                                try {
                                                    // 실제 세션 검증
                                                    const isValidSession = await checkMallSession();
                                                    if (isValidSession) {
                                                        // 검증 성공 시 최신 세션 정보로 이동
                                                        const currentSession = sessionStore.getState();
                                                        if (currentSession.mallId) {
                                                            navigate(`/mall/${currentSession.mallId}`);
                                                        } else {
                                                            navigate('/switch');
                                                        }
                                                        return;
                                                    }
                                                } catch (error) {
                                                    console.error('세션 검증 실패:', error);
                                                }
                                            }

                                            // 세션이 없거나 검증 실패 시 로그인 팝업 표시
                                            dialogOpen({
                                                innerElement: (
                                                    <LoginDialog
                                                        onLoginSuccess={() => {
                                                            const currentSession = sessionStore.getState();
                                                            if (currentSession.mallId) {
                                                                navigate(`/mall/${currentSession.mallId}`);
                                                            } else {
                                                                navigate('/switch');
                                                            }
                                                        }}
                                                    />
                                                ),
                                                maxWidth: false,
                                                sx: {
                                                    '& .MuiDialog-paper': {
                                                        maxWidth: '420px',
                                                        width: '100%',
                                                    },
                                                },
                                            });
                                        }}
                                        sx={isSodomall ? { borderRadius: '20px' } : soduActionSx(isMallManageActive)}
                                    >
                                        {t('mall.mallManagement')}
                                    </Button>
                                    {/* 자동DM */}
                                    <Button
                                        variant={isSodomall ? (isAutoDmActive ? 'contained' : 'outlined') : 'contained'}
                                        disableElevation
                                        disabled={env === 'production'}
                                        color={isSodomall ? 'info' : undefined}
                                        onClick={async () => {
                                            // 실제 세션 검증 후 처리 (오래된 세션 방지)
                                            const session = sessionStore.getState();

                                            if (session.accessToken && session.userId) {
                                                try {
                                                    const isValidSession = await checkMallSession();
                                                    if (isValidSession) {
                                                        navigate('/auto-dm');
                                                        return;
                                                    }
                                                } catch (error) {
                                                    console.error('세션 검증 실패:', error);
                                                }
                                            }

                                            // 세션이 없거나 검증 실패 시 로그인 팝업 표시
                                            dialogOpen({
                                                innerElement: (
                                                    <LoginDialog
                                                        onLoginSuccess={() => {
                                                            navigate('/auto-dm');
                                                        }}
                                                    />
                                                ),
                                                maxWidth: false,
                                                sx: {
                                                    '& .MuiDialog-paper': {
                                                        maxWidth: '420px',
                                                        width: '100%',
                                                    },
                                                },
                                            });
                                        }}
                                        sx={isSodomall ? { borderRadius: '20px' } : soduActionSx(isAutoDmActive)}
                                    >
                                        {env === 'production' ? '준비중' : '자동DM'}
                                    </Button>
                                    {/* AI로 만들기 (캐러셀·캐리커쳐 드롭다운) */}
                                    <Button
                                        variant={
                                            isSodomall
                                                ? isCarouselActive || isCaricatureActive
                                                    ? 'contained'
                                                    : 'outlined'
                                                : 'contained'
                                        }
                                        disableElevation
                                        color={isSodomall ? 'info' : undefined}
                                        onClick={(e) => setAiMenuAnchor(e.currentTarget)}
                                        endIcon={<KeyboardArrowDownIcon />}
                                        sx={
                                            isSodomall
                                                ? { borderRadius: '20px' }
                                                : soduActionSx(isCarouselActive || isCaricatureActive)
                                        }
                                    >
                                        AI로 만들기
                                    </Button>
                                    <Menu
                                        anchorEl={aiMenuAnchor}
                                        open={Boolean(aiMenuAnchor)}
                                        onClose={() => setAiMenuAnchor(null)}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        MenuListProps={{ sx: { p: 0 } }}
                                        PaperProps={{
                                            sx: {
                                                mt: 1.25,
                                                p: 1,
                                                minWidth: 248,
                                                borderRadius: '18px',
                                                border: '1px solid rgba(255,107,157,0.14)',
                                                boxShadow: '0 16px 40px rgba(255,107,157,0.20), 0 4px 12px rgba(0,0,0,0.06)',
                                                overflow: 'visible',
                                                // 말풍선 꼬리
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: -6,
                                                    left: 28,
                                                    width: 12,
                                                    height: 12,
                                                    bgcolor: '#fff',
                                                    borderLeft: '1px solid rgba(255,107,157,0.14)',
                                                    borderTop: '1px solid rgba(255,107,157,0.14)',
                                                    transform: 'rotate(45deg)',
                                                },
                                            },
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                px: 1.5,
                                                pt: 0.5,
                                                pb: 0.75,
                                                fontSize: 11,
                                                fontWeight: 800,
                                                letterSpacing: '0.06em',
                                                color: 'text.disabled',
                                            }}
                                        >
                                            AI로 만들기
                                        </Typography>
                                        {[
                                            {
                                                key: 'carousel',
                                                to: '/carousel',
                                                label: '캐러셀',
                                                desc: '상품 카드 이미지 세트',
                                                icon: <ViewCarouselRoundedIcon sx={{ fontSize: 20 }} />,
                                                active: isCarouselActive,
                                            },
                                            {
                                                key: 'caricature',
                                                to: '/caricature',
                                                label: '캐리커쳐',
                                                desc: '얼굴로 AI 캐릭터 생성',
                                                icon: <BrushRoundedIcon sx={{ fontSize: 20 }} />,
                                                active: isCaricatureActive,
                                            },
                                        ].map((item) => (
                                            <MenuItem
                                                key={item.key}
                                                selected={item.active}
                                                onClick={() => {
                                                    setAiMenuAnchor(null);
                                                    navigateWithSessionGuard(item.to);
                                                }}
                                                sx={{
                                                    borderRadius: '12px',
                                                    px: 1.25,
                                                    py: 1,
                                                    gap: 1.25,
                                                    alignItems: 'center',
                                                    '&:hover': { bgcolor: SODU_BRAND_SOFT },
                                                    '&.Mui-selected, &.Mui-selected:hover': { bgcolor: SODU_BRAND_SOFT },
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 38,
                                                        height: 38,
                                                        borderRadius: '11px',
                                                        flexShrink: 0,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: item.active ? '#fff' : SODU_BRAND_HOVER,
                                                        background: item.active
                                                            ? 'linear-gradient(135deg, #ff8bb7 0%, #ff6b9d 100%)'
                                                            : SODU_BRAND_SOFT,
                                                    }}
                                                >
                                                    {item.icon}
                                                </Box>
                                                <Box sx={{ minWidth: 0 }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#2b2b2b', lineHeight: 1.3 }}>
                                                        {item.label}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: 12, color: 'text.secondary', lineHeight: 1.3 }}>
                                                        {item.desc}
                                                    </Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            )}

                            {/* 스페이서 */}
                            <Box sx={{ flex: 1 }} />

                            {/* 우측 아이콘 */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.3, md: 0.5 } }}>
                                {/* 소도몰 사용자 전용: 판매링크 바로가기 버튼 (메뉴 외부) */}
                                {isUserLoggedIn && isSodomall && (
                                    <Button
                                        variant="contained"
                                        color="info"
                                        startIcon={<LanguageIcon />}
                                        onClick={() => {
                                            if (effectiveMallPath) {
                                                const baseUrl =
                                                    env !== 'prd'
                                                        ? 'https://sodomall.dev.flowing.space'
                                                        : 'https://sodomall.store';
                                                const url = `${baseUrl}/${effectiveMallPath}`;
                                                window.open(url, '_blank');
                                            }
                                        }}
                                        sx={{
                                            borderRadius: '20px',
                                            mr: 1.5,
                                            px: 2,
                                            py: 0.8,
                                            fontSize: 14,
                                            fontWeight: 500,
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        판매링크 바로가기
                                    </Button>
                                )}

                                {/* 글로릴스 연동 진입은 프로필링크 편집기 고정 블록으로 이동 — 네비바 버튼 제거 */}
                                {/* 자동 연동 안내 팝업 제거 — 수동 "가져오기" 모델로 전환(오너 기획 변경). */}
                                {/* {isUserLoggedIn && !isSodomall && <GloreelsLinkNotice />} */}

                                {/* 사용자 프로필 - Workspace + User 2단 카드 */}
                                {isUserLoggedIn ? (
                                    <Box
                                        sx={userProfileBoxSx}
                                        onClick={(event: React.MouseEvent<HTMLElement>) => {
                                            handleUserMenuOpen(event);
                                        }}
                                    >
                                        <Avatar src={image_url || undefined} sx={userProfileAvatarSx}>
                                            {!image_url && (nickname?.[0]?.toUpperCase() || 'U')}
                                        </Avatar>
                                        {!isMobile && (
                                            <>
                                                <Box sx={userProfileTextWrapperSx}>
                                                    {currentMallName && (
                                                        <Typography component="span" sx={userProfileMallSx}>
                                                            <StorefrontOutlinedIcon />
                                                            {currentMallName}
                                                        </Typography>
                                                    )}
                                                    <Typography component="span" sx={userProfileNameSx}>
                                                        {nickname || '사용자'}
                                                    </Typography>
                                                </Box>
                                                <KeyboardArrowDownIcon
                                                    className="profile-caret"
                                                    sx={userProfileCaretSx}
                                                />
                                            </>
                                        )}
                                    </Box>
                                ) : (
                                    <Button
                                        onClick={() => {
                                            dialogOpen({
                                                innerElement: <LoginDialog />,
                                                maxWidth: false,
                                                sx: {
                                                    '& .MuiDialog-paper': {
                                                        maxWidth: '420px',
                                                        width: '100%',
                                                    },
                                                },
                                            });
                                        }}
                                        sx={loginButtonSx}
                                    >
                                        {t('auth.login')}
                                    </Button>
                                )}

                                {/* 사용자 드롭다운 메뉴 */}
                                <Menu
                                    anchorEl={userMenuAnchor}
                                    open={Boolean(userMenuAnchor)}
                                    onClose={handleUserMenuClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    disableAutoFocusItem
                                    disableEnforceFocus
                                    disableRestoreFocus
                                    sx={userDropdownMenuSx}
                                >
                                    {/* 프로필링크 바로가기 - 소도몰 역할일 때 숨김 (외부 버튼으로 대체) */}
                                    {!isSodomall && (
                                        <MenuItem
                                            onClick={() => {
                                                if (effectiveMallPath) {
                                                    window.open(`${getSpacehomeUrl()}/${effectiveMallPath}`, '_blank');
                                                }
                                                handleUserMenuClose();
                                            }}
                                        >
                                            <ListItemIcon sx={userDropdownIconWrapperSx}>
                                                <LanguageIcon sx={userDropdownIconSx} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={t('studio.profileLinkDirectAccess')}
                                                sx={userDropdownTextSx}
                                            />
                                        </MenuItem>
                                    )}
                                    {/* 쇼핑몰 바로가기 - 소도몰 역할일 때 숨김 */}
                                    {!isSodomall && (
                                        <MenuItem
                                            onClick={() => {
                                                if (effectiveMallPath) {
                                                    window.open(
                                                        `${getFlowingMallUrl()}/${effectiveMallPath}`,
                                                        '_blank',
                                                    );
                                                } else {
                                                    navigate('/switch');
                                                }
                                                handleUserMenuClose();
                                            }}
                                        >
                                            <ListItemIcon sx={userDropdownIconWrapperSx}>
                                                <StorefrontOutlinedIcon sx={userDropdownIconSx} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={t('mall.mallDirectAccess')}
                                                sx={userDropdownTextSx}
                                            />
                                        </MenuItem>
                                    )}
                                    <Divider sx={userDropdownDividerSx} />
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`/studio/${userId}/user-setting`);
                                            handleUserMenuClose();
                                        }}
                                    >
                                        <ListItemIcon sx={userDropdownIconWrapperSx}>
                                            <SettingsIcon sx={userDropdownIconSx} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={t('navigation.accountSettings')}
                                            sx={userDropdownTextSx}
                                        />
                                    </MenuItem>
                                    <Divider sx={userDropdownDividerSx} />
                                    <MenuItem onClick={handleLogout}>
                                        <ListItemIcon sx={userDropdownIconWrapperSx}>
                                            <LogoutIcon sx={userDropdownIconSx} />
                                        </ListItemIcon>
                                        <ListItemText primary={t('auth.logout')} sx={userDropdownTextSx} />
                                    </MenuItem>
                                </Menu>

                                {/* 국가 선택 UI - 맨 오른쪽에 배치 (소도몰 역할일 때 숨김) */}
                                {/* {!isMobile && !isSodomall && (
                                    <CountrySelector
                                        selectedCountry={selectedCountry}
                                        onCountryChange={handleCountryChange}
                                        sx={{ ml: 1 }}
                                    />
                                )} */}
                            </Box>
                        </Toolbar>
                    </Box>
                </AppBar>
            </Box>

            {/* 모바일 메뉴 드로어 */}
            {isMobile && mobileMenuOpen && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 60,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#fff',
                        zIndex: 1200,
                        overflowY: 'auto',
                        borderTop: '1px solid #e0e0e0',
                    }}
                >
                    <Box sx={{ p: 2 }}>
                        {/* 모바일 국가 선택 UI (소도몰 역할일 때 숨김) */}
                        {/* {!isSodomall && (
                            <Box sx={{ mb: 2, pb: 2, borderBottom: '1px solid #f0f0f0' }}>
                                <CountrySelector
                                    selectedCountry={selectedCountry}
                                    onCountryChange={handleCountryChange}
                                />
                            </Box>
                        )} */}

                        {isUserLoggedIn ? (
                            <>
                                {/* 몰 관리 */}
                                <Button
                                    fullWidth
                                    onClick={async () => {
                                        setMobileMenuOpen(false);

                                        const session = sessionStore.getState();

                                        if (session.accessToken && session.userId) {
                                            try {
                                                const isValidSession = await checkMallSession();
                                                if (isValidSession) {
                                                    const currentSession = sessionStore.getState();
                                                    if (currentSession.mallId) {
                                                        navigate(`/mall/${currentSession.mallId}`);
                                                    } else {
                                                        navigate('/switch');
                                                    }
                                                    return;
                                                }
                                            } catch (error) {
                                                console.error('세션 검증 실패:', error);
                                            }
                                        }

                                        dialogOpen({
                                            innerElement: (
                                                <LoginDialog
                                                    onLoginSuccess={() => {
                                                        const currentSession = sessionStore.getState();
                                                        if (currentSession.mallId) {
                                                            navigate(`/mall/${currentSession.mallId}`);
                                                        } else {
                                                            navigate('/switch');
                                                        }
                                                    }}
                                                />
                                            ),
                                            maxWidth: false,
                                            sx: {
                                                '& .MuiDialog-paper': {
                                                    maxWidth: '420px',
                                                    width: '100%',
                                                },
                                            },
                                        });
                                    }}
                                    sx={
                                        isSodomall
                                            ? {
                                                  justifyContent: 'flex-start',
                                                  color: '#222',
                                                  fontSize: 15,
                                                  fontWeight: 500,
                                                  py: 2,
                                                  borderBottom: '1px solid #f0f0f0',
                                                  textTransform: 'none',
                                              }
                                            : flowingMobileItemSx
                                    }
                                >
                                    {t('mall.mallManagement')}
                                </Button>

                                {/* 프로필링크 */}
                                <Button
                                    fullWidth
                                    onClick={async () => {
                                        setMobileMenuOpen(false);

                                        const session = sessionStore.getState();

                                        if (session.accessToken && session.userId) {
                                            try {
                                                const isValidSession = await checkMallSession();
                                                if (isValidSession) {
                                                    navigate(`/studio/${userId}`);
                                                    return;
                                                }
                                            } catch (error) {
                                                console.error('세션 검증 실패:', error);
                                            }
                                        }

                                        dialogOpen({
                                            innerElement: (
                                                <LoginDialog
                                                    onLoginSuccess={() => {
                                                        navigate(`/studio/${userId}`);
                                                    }}
                                                />
                                            ),
                                            maxWidth: false,
                                            sx: {
                                                '& .MuiDialog-paper': {
                                                    maxWidth: '420px',
                                                    width: '100%',
                                                },
                                            },
                                        });
                                    }}
                                    sx={
                                        isSodomall
                                            ? {
                                                  justifyContent: 'flex-start',
                                                  color: '#222',
                                                  fontSize: 15,
                                                  fontWeight: 500,
                                                  py: 2,
                                                  borderBottom: '1px solid #f0f0f0',
                                                  textTransform: 'none',
                                              }
                                            : flowingMobileItemSx
                                    }
                                >
                                    {t('studio.profileLinkManagement')}
                                </Button>

                                {/* 캐러셀 */}
                                <Button
                                    fullWidth
                                    onClick={() => {
                                        setMobileMenuOpen(false);
                                        navigateWithSessionGuard('/carousel');
                                    }}
                                    sx={
                                        isSodomall
                                            ? {
                                                  justifyContent: 'flex-start',
                                                  color: '#222',
                                                  fontSize: 15,
                                                  fontWeight: 500,
                                                  py: 2,
                                                  borderBottom: '1px solid #f0f0f0',
                                                  textTransform: 'none',
                                              }
                                            : flowingMobileItemSx
                                    }
                                >
                                    캐러셀
                                </Button>
                                {/* 캐리커쳐 */}
                                <Button
                                    fullWidth
                                    onClick={() => {
                                        setMobileMenuOpen(false);
                                        navigateWithSessionGuard('/caricature');
                                    }}
                                    sx={
                                        isSodomall
                                            ? {
                                                  justifyContent: 'flex-start',
                                                  color: '#222',
                                                  fontSize: 15,
                                                  fontWeight: 500,
                                                  py: 2,
                                                  borderBottom: '1px solid #f0f0f0',
                                                  textTransform: 'none',
                                              }
                                            : flowingMobileItemSx
                                    }
                                >
                                    캐리커쳐
                                </Button>
                            </>
                        ) : (
                            /* 구경하기 */
                            <Button
                                fullWidth
                                onClick={() => {
                                    setMobileMenuOpen(false);
                                    navigate('/');
                                }}
                                sx={
                                    isSodomall
                                        ? {
                                              justifyContent: 'flex-start',
                                              color: '#222',
                                              fontSize: 15,
                                              fontWeight: 500,
                                              py: 2,
                                              borderBottom: '1px solid #f0f0f0',
                                              textTransform: 'none',
                                          }
                                        : flowingMobileItemSx
                                }
                            >
                                {t('navigation.browseNewArrivals')}
                            </Button>
                        )}
                    </Box>
                </Box>
            )}
        </>
    );
};

export default DDMNavBar;
